import { createSlice } from "@reduxjs/toolkit";
import { IConfigSliceProps } from "../../config/commonInterfaces";
import { clearStore } from "../actions";
import { EMPTY_APP_CONFIG, OTP_LENGTH, V2 } from "../../data/constants";
import { defaultExtraAirtimeConfig } from "../../data/paymentMethod";
import { defaultAddToHomeConfig, defaultTransactionSummaryConfig } from "../../data/defaultUIConfig";

const initialState: IConfigSliceProps = {
  launchConfig: {
    isOtpFlowEnable:true,
    newSendOtpLoaderFlag: false,
    isAutoLoginEnable: false,
    downloadLink: "",
    phoneCode: "",
    lang: "",
    otpTimer: "",
    msisdnLength: "",
    ga4Id: "",
    betaUsers: [],
    allBetaFeatureCodes: [],
    disableRightClick: false,
    amOptions: [],
    gsmBalConfigs: [],
    appSettingsConfigs: [{
      code: "",
      icon: "",
      type: "",
      paramObj: { pageUrl: "" },
    }],
    helpAndSupportConfig: {
      contactUsConfigs: [],
      findUsOnConfigs: []
    },
    version: V2,
    featureMap: {},
    popularRecharges: [],
    buyGoodsConfig: {
      vendorConfigs: [],
      searchText: "",
      enableHint: false,
    },
    withdrawCashConfig: {
      agentCodeRegex: "",
      agentCodeMinLength: 0,
      agentCodeMaxLength: 0,
      agentCodeInputMode: "numeric",
      showAgentCodeField: true,
      searchText: "",
      showVerifyBtn: false,
      enableHint: false,
      agentCodeKey: "agentCode",
      amountConfig: null as any
    },
    paymentMethodConfig: null as any,
    MPESAConfig: {
      remainingTimeSecs: 0.1 * 60,
      enquiryIntervalMillis: 1000,
      enquiriesAllowed: 1
    },
    showShare: false,
    sessionTimeout: 10,
    autoLogout: false,
    showExitPopup: false,
    buyBundleConfig: {
      tabsId: [],
      bundleEventObj: {} as any,
      bundleGuestEventObj: {} as any,
      bundleAllowedCategories: [],
      bundleAllowedPeriodsWithOrder: [],
      comboTabCategoriesOrder: [],
      microSiteConfig: {
        bannerText: "",
        enableBanner: false,
        betaCode: ""
      }
    },
    payBillsConfig: null as any,
    enableSecureSms: false,
    secureSmsNonSupportedBrowsers: [],
    secureSmsTimeout: 0,
    secureSmsDelay: 0,
    transactionLimConfig: null as any,
    amTransactionHistoryConfig: null as any,
    gsmTxnHistoryConfig: null as any,
    supportedBrowsers: {},
    hesupportedBrowsers: {},
    gasupportedBrowsers: {},
    minimumScreenWidth: "",
    noAuthCheckRoutes: [],
    numberOfFetchAMTransactions: 0,
    locateUsLink: "",
    languageConfig: {
      supportedLanguages: []
    },
    heInitUrl: "",
    autoHeInit: false,
    heMandatory: true,
    heUnsupportedBrowser: {},
    isHeDisable: true,
    heOtpFlowEnable: true,
    isTempPinEnabledInOPCO: false,
    isDisableOtpPaste: true,
    isChangePin: false,
    guestConfig: {
      isEnabled: false,
      remainingTimeSecs: 0.1 * 60,
      enquiryIntervalMillis: 1000,
      enquiriesAllowed: 1,
      transactionLimConfig: {
        IS_ENABLED: false,
        PREPAID_RECHARGE: false
      },
      otpPinFlow: {
        isEnable: false,
        betaCode: ''
      }
    },
    securityQuestions: {
      ansMinLength: 4,
      ansMaxLength: 16
    },
    betaFeatureMap: {},
    ussd_am_code: "",
    enableUnlockPin: true,
    dualCurrency: {
      usdConversionValue: 100
    },
    amountMaxLength: 20,
    showAmBalDecimal: true,
    payXEnabled: false,
    tipsForSetPin: [1, 2, 3],
    enableServerSideTagging: false,
    serverContainerUrl: "",
    serverSideTaggingUrl: "",
    addToHomeConfig: defaultAddToHomeConfig,
    loanConfig: {
      betaCode: "",
      loanConsentPoints: [1, 2, 3],
      isEnabled: true,
      loanType: 'GSM',
      historyConfig: {
        navTab: {
          data: []
        },
        numberOfTransaction: 10,
        noTransactionFoundDisclaimerKey: "",
        dateFormat: "DD MMM YYYY, h:mm a"
      },
      loanCategoryList: [],
      loanCardConfig: {
        showLoanSummary: true,
        showAirtimeLoanCard: false,
        showBundleLoanCard: false,
        showDescriptionInCatList: false,
        showPayOptLoanCard:false
      }
    },
    webEngageLimits: {
      minAMBalance: 0,
      minAirtimeBalance: 0,
      minDataBalance: 0,
      minDataBalanceUnit: "",
      minSMSBalance: 0,
      minVoiceBalance: 0
    },
    sendMoneyConfig: {
      enableMiddleName: false,
      isPurposeEnabled: false,
      purposeList: [],
      searchType: "",
      amountConfig: null as any
    },
    webEngageConfig: {
      isEventsEnabled: false,
      isUserAttributeEnabled: false
    },
    webPageConfig: {
      isEnable: false,
      isPayBillEnable: false,
      sliderArray: [1, 2, 3, 4, 5]
    },
    enableQsg: false,
    maxScreenWidthOfTablet: 1080,
    darkModeConfig: {
      isEnable: false,
      betaCode: 'darkMode'
    },
    offlineConfig: {
      isEnable: true,
      betaCode: "",
    },
    enableSetPin: false,
    enableSetQuestion: false,
    showDABalance: false,
    extraAirtimeConfig: defaultExtraAirtimeConfig,
    secureCheckoutConfig: {
      betaCode: '',
      isEnable: false
    },
    transactionSummaryConfig: defaultTransactionSummaryConfig,
    isAutoOTPEnabled: false,
    forgotNumberConfig: {
      isEnable: false,
      dialerNo: ""
    },
    otherServices: [],
    dashboardConfig: {
      showAMCard: false,
      showAMTransactionHistoryCard: false,
      bestSellerBundleCardConfig: {
        enable: false,
        bundleCount: 3
      }
    },
    smartcashSecureConfig: {
      isEnabled: false,
      betaCode: "",
      otpConfig: {
        resendOtpTimer: 30,
        otpLength: OTP_LENGTH,
      },
      pinConfig: {
        showCloseIcn: false,
        pinLength: 4
      }
    },
    smallDeviceConfig: {
      width: 321,
      height: 531
    },
    paymentGatewayConfig: {
      PAYSTACK: {
        betaCode: "",
        name: "",
        isEnabled: false,
        publicKey: "",
        allowedPayOptions: [],
        emailConfig: {
          emailRegex: "",
          maxEmailLength: 100
        }
      },
      UBA: {
        betaCode: "",
        name: "",
        isEnabled: false,
        publicKey: "",
        allowedPayOptions: [],
        emailConfig: {
          emailRegex: "",
          maxEmailLength: 100
        }
      }
    },
    responsiveModeEnable: false,
    customEventMgmtConfig: {
      eventsEnabled: false
    },
    seoConfig: {
      description: "",
      keywords: ""
    },
    buyAirtimeConfig: {
      amountConfig: null as any
    },
    enableMsisdnSpace: false
  },
  basicConfig: {
    customerCareNo: "",
    msisdnLength: "",
    backgroundThreadFreq: "",
    currency: [],
    ussdGSMCode: "",
    ussdAMCode: "",
    otpAttempts: "",
    recentContactsCount: "",
    invalidAMPinStatuses: [],
    bundleType: [],
    rechargeAirtimeFav: undefined,
    buyBundleFav: undefined,
    sendMoneyFav: undefined,
    payBillFav: undefined,
    ussdPayBillCode: ""
  },
  homeConfig: [],
  homeConfigTimestamp: "",
  balanceConfig: [],
  userAttribute: "",
  transactionLimitConfig: { isFetched: false, limitConfig: null }
};

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    callTransactionLimitConfigApi: (state, action) => {

    },
    transactionLimitConfigApiSucess: (state, action) => {
      state.transactionLimitConfig = { isFetched: true, limitConfig: action.payload };
    },
    transactionLimitConfigApiFailed: (state, action) => {
      state.transactionLimitConfig = { isFetched: false, limitConfig: null }
    },
    callConfigApi: (state, action) => {
    },
    configApiSucess: (state, action) => {
    },
    configApiFailed: (state, action) => {
    },

    //launch config
    callLaunchConfigApi: (state, action) => {

    },
    launchConfigApiSucess: (state, action) => {
      if (!state.launchConfig) {
        state.launchConfig = { ...initialState.launchConfig };
      }
      const configData = action.payload?.data?.[0];
      state.launchConfig = {
        isOtpFlowEnable:configData?.isOtpFlowEnable ?? true,
        newSendOtpLoaderFlag: configData?.newSendOtpLoaderFlag ?? false,
        isAutoLoginEnable: configData?.isAutoLoginEnable ?? false,
        lang: configData?.locale ?? "",
        downloadLink: configData?.downloadLink ?? "",
        phoneCode: configData?.phone_code ?? "",
        otpTimer: configData?.otp_timer ?? "",
        msisdnLength: configData?.msisdn_length ?? "",
        ga4Id: configData?.ga4Id ?? "",
        betaUsers: configData?.beta_users ?? [],
        allBetaFeatureCodes: configData?.allBetaFeatureCodes ?? [],
        disableRightClick: configData?.disable_right_click ?? false,
        amOptions: configData?.amOptions ?? [],
        gsmBalConfigs: configData?.gsmBalConfigs ?? [],
        appSettingsConfigs: configData?.appSettingsConfigs ?? [EMPTY_APP_CONFIG],
        helpAndSupportConfig: {
          contactUsConfigs: configData?.helpAndSupportConfig?.contactUsConfigs ?? [],
          findUsOnConfigs: configData?.helpAndSupportConfig?.findUsOnConfigs ?? []
        },
        version: configData?.version ?? V2,
        featureMap: configData?.feature_map ?? {},
        popularRecharges: configData?.popularRecharges ?? [],
        buyGoodsConfig: {
          vendorConfigs: configData?.buyGoodsConfig?.vendorConfigs ?? [],
          searchText: configData?.buyGoodsConfig?.searchText ?? "",
          enableHint: configData?.buyGoodsConfig?.enableHint ?? false,
        },
        withdrawCashConfig: {
          agentCodeRegex: configData?.withdrawCashConfig?.agentCodeRegex ?? "",
          agentCodeMinLength: configData?.withdrawCashConfig?.agentCodeMinLength ?? 0,
          agentCodeMaxLength: configData?.withdrawCashConfig?.agentCodeMaxLength ?? 0,
          agentCodeInputMode: configData?.withdrawCashConfig?.agentCodeInputMode ?? "numeric",
          showAgentCodeField: configData?.withdrawCashConfig?.showAgentCodeField ?? true,
          searchText: configData?.withdrawCashConfig?.searchText ?? "",
          showVerifyBtn: configData?.withdrawCashConfig?.showVerifyBtn ?? false,
          enableHint: configData?.withdrawCashConfig?.enableHint ?? false,
          agentCodeKey: configData?.withdrawCashConfig?.agentCodeKey ?? "agentCode",
          amountConfig: configData?.withdrawCashConfig?.amountConfig ?? null as any
        },
        paymentMethodConfig: configData?.paymentMethodConfig ?? null as any,
        MPESAConfig: {
          remainingTimeSecs: configData?.MPESAConfig?.remainingTimeSecs ?? 0.1 * 60,
          enquiryIntervalMillis: configData?.MPESAConfig?.enquiryIntervalMillis ?? 1000,
          enquiriesAllowed: configData?.MPESAConfig?.enquiriesAllowed ?? 1
        },
        showShare: configData?.showShare ?? false,
        sessionTimeout: configData?.sessionTimeout ?? 10,
        autoLogout: configData?.autoLogout ?? false,
        showExitPopup: configData?.showExitPopup ?? false,
        buyBundleConfig: {
          tabsId: configData?.buyBundleConfig?.tabsId ?? [],
          bundleEventObj: configData?.buyBundleConfig?.bundleEventObj ?? {} as any,
          bundleGuestEventObj: configData?.buyBundleConfig?.bundleGuestEventObj ?? {} as any,
          bundleAllowedCategories: configData?.buyBundleConfig?.bundleAllowedCategories ?? [],
          bundleAllowedPeriodsWithOrder: configData?.buyBundleConfig?.bundleAllowedPeriodsWithOrder ?? [],
          comboTabCategoriesOrder: configData?.buyBundleConfig?.comboTabCategoriesOrder ?? [],
          microSiteConfig: {
            bannerText: configData?.buyBundleConfig?.microSiteConfig?.bannerText ?? "",
            enableBanner: configData?.buyBundleConfig?.microSiteConfig?.enableBanner ?? false,
            betaCode: configData?.buyBundleConfig?.microSiteConfig?.betaCode ?? ""
          }
        },
        enableSecureSms: configData?.enableSecureSms ?? false,
        secureSmsNonSupportedBrowsers: configData?.secureSmsNonSupportedBrowsers ?? [],
        secureSmsTimeout: configData?.secureSmsTimeout ?? 0,
        secureSmsDelay: configData?.secureSmsDelay ?? 0,
        transactionLimConfig: configData?.transactionLimConfig ?? null as any,
        amTransactionHistoryConfig: configData?.amTransactionHistoryConfig ?? null as any,
        gsmTxnHistoryConfig: configData?.gsmTxnHistoryConfig ?? null as any,
        supportedBrowsers: configData?.supportedBrowsers ?? {},
        hesupportedBrowsers: configData?.hesupportedBrowsers ?? {},
        gasupportedBrowsers: configData?.gasupportedBrowsers ?? {},
        minimumScreenWidth: configData?.minimumScreenWidth ?? "",
        noAuthCheckRoutes: configData?.noAuthCheckRoutes ?? [],
        numberOfFetchAMTransactions: configData?.numberOfFetchAMTransactions ?? 0,
        locateUsLink: configData?.locateUsLink ?? "",
        languageConfig: {
          supportedLanguages: configData?.languageConfig?.supportedLanguages ?? []
        },
        heInitUrl: configData?.heInitUrl ?? "",
        autoHeInit: configData?.autoHeInit ?? false,
        heMandatory: configData?.heMandatory ?? true,
        heUnsupportedBrowser: configData?.heUnsupportedBrowser ?? {},
        isHeDisable: configData?.isHeDisable ?? true,
        heOtpFlowEnable: configData?.heOtpFlowEnable ?? true,
        isTempPinEnabledInOPCO: configData?.isTempPinEnabledInOPCO ?? false,
        isDisableOtpPaste: configData?.isDisableOtpPaste ?? true,
        isChangePin: configData?.isChangePin ?? false,
        guestConfig: {
          isEnabled: configData?.guestConfig?.isEnabled ?? false,
          remainingTimeSecs: configData?.guestConfig?.remainingTimeSecs ?? 0.1 * 60,
          enquiryIntervalMillis: configData?.guestConfig?.enquiryIntervalMillis ?? 1000,
          enquiriesAllowed: configData?.guestConfig?.enquiriesAllowed ?? 1,
          transactionLimConfig: {
            IS_ENABLED: configData?.guestConfig?.transactionLimConfig?.IS_ENABLED ?? false,
            PREPAID_RECHARGE: configData?.guestConfig?.transactionLimConfig?.PREPAID_RECHARGE ?? false,
          },
          otpPinFlow: configData?.guestConfig?.otpPinFlow ?? {}
        },
        securityQuestions: {
          ansMinLength: configData?.securityQuestions?.ansMinLength ?? 4,
          ansMaxLength: configData?.securityQuestions?.ansMaxLength ?? 16
        },
        dualCurrency: {
          usdConversionValue: configData?.dualCurrency?.usdConversionValue ?? 100
        },
        betaFeatureMap: configData?.betaFeatureMap ?? {},
        ussd_am_code: configData?.ussd_am_code ?? "",
        enableUnlockPin: configData?.enableUnlockPin ?? true,
        amountMaxLength: configData?.amountMaxLength ?? 20,
        showAmBalDecimal: configData?.showAmBalDecimal ?? true,
        payXEnabled: configData?.payXEnabled ?? false,
        tipsForSetPin: configData?.tipsForSetPin ?? [1, 2, 3],
        enableServerSideTagging: configData?.enableServerSideTagging ?? false,
        serverContainerUrl: configData?.serverContainerUrl ?? "",
        serverSideTaggingUrl: configData?.serverSideTaggingUrl ?? "",
        addToHomeConfig: {
          ...configData?.addToHomeConfig,
          dashboard: configData?.addToHomeConfig?.dashboard ?? defaultAddToHomeConfig.dashboard,
          addToHomePopUp: configData?.addToHomeConfig?.addToHomePopUp ?? defaultAddToHomeConfig.addToHomePopUp
        },
        loanConfig: configData?.loanConfig ?? { ...initialState?.launchConfig?.loanConfig },
        webEngageLimits: {
          minAMBalance: configData?.webEngageLimits?.minAMBalance ?? 0,
          minAirtimeBalance: configData?.webEngageLimits?.minAirtimeBalance ?? 0,
          minDataBalance: configData?.webEngageLimits?.minDataBalance ?? 0,
          minDataBalanceUnit: configData?.webEngageLimits?.minDataBalanceUnit ?? "",
          minSMSBalance: configData?.webEngageLimits?.minSMSBalance ?? 0,
          minVoiceBalance: configData?.webEngageLimits?.minVoiceBalance ?? 0
        },
        sendMoneyConfig: {
          enableMiddleName: configData?.sendMoneyConfig?.enableMiddleName ?? false,
          isPurposeEnabled: configData?.sendMoneyConfig?.isPurposeEnabled ?? false,
          purposeList: configData?.sendMoneyConfig?.purposeList ?? [],
          searchType: configData?.sendMoneyConfig?.searchType ?? "",
          amountConfig: configData?.sendMoneyConfig?.amountConfig ?? null as any
        },
        webEngageConfig: {
          isEventsEnabled: configData?.webEngageConfig?.isEventsEnabled ?? false,
          isUserAttributeEnabled: configData?.webEngageConfig?.isUserAttributeEnabled ?? false,
        },
        webPageConfig: {
          isEnable: configData?.webPageConfig?.isEnable ?? false,
          isPayBillEnable: configData?.webPageConfig?.isPayBillEnable ?? false,
          sliderArray: configData?.webPageConfig?.sliderArray ?? [1, 2, 3, 4, 5]
        },
        enableQsg: configData?.enableQsg ?? false,
        maxScreenWidthOfTablet: configData?.maxScreenWidthOfTablet ?? 1080,
        darkModeConfig: {
          isEnable: configData?.darkModeConfig?.isEnable ?? false,
          betaCode: configData?.darkModeConfig?.betaCode ?? 'darkMode'
        },
        offlineConfig: {
          isEnable: configData?.offlineConfig?.isEnable ?? false,
          betaCode: configData?.offlineConfig?.betaCode ?? ''
        },
        enableSetPin: configData?.enableSetPin ?? false,
        enableSetQuestion: configData?.enableSetQuestion ?? false,
        payBillsConfig: {
          transactionType: configData?.payBillsConfig?.transactionType ?? "",
          vendorConfigs: configData?.payBillsConfig?.vendorConfigs ?? [],
          validationConfig: configData?.payBillsConfig?.validationConfig ?? { number: { max: 10 }, text: { max: 100 }, fav: { max: 10 } },
          amountPlaceholder: configData?.payBillsConfig?.amountPlaceholder ?? "0.00",
        },
        showDABalance: configData?.showDABalance ?? false,
        extraAirtimeConfig: configData?.extraAirtimeConfig ?? defaultExtraAirtimeConfig,
        secureCheckoutConfig: configData?.secureCheckoutConfig ?? {
          betaCode: '',
          isEnable: false
        },
        transactionSummaryConfig: {
          ...configData?.transactionSummaryConfig,
          continueBtn: configData?.transactionSummaryConfig?.continueBtn ?? defaultTransactionSummaryConfig.continueBtn
        },
        isAutoOTPEnabled: configData?.isAutoOTPEnabled ?? false,
        forgotNumberConfig: configData?.forgotNumberConfig ?? {
          isEnable: false,
          dialerNo: ""
        },
        otherServices: configData?.otherServices ?? [],
        dashboardConfig: {
          showAMCard: configData?.dashboardConfig?.showAMCard ?? false,
          showAMTransactionHistoryCard: configData?.dashboardConfig?.showAMTransactionHistoryCard ?? false,
          bestSellerBundleCardConfig: {
            enable: configData?.dashboardConfig?.bestSellerBundleCardConfig?.enable ?? false,
            bundleCount: configData?.dashboardConfig?.bestSellerBundleCardConfig?.bundleCount ?? 3
          }
        },
        smartcashSecureConfig: {
          isEnabled: configData?.smartcashSecureConfig?.isEnabled ?? false,
          betaCode: configData?.smartcashSecureConfig?.betaCode ?? "",
          otpConfig: {
            resendOtpTimer: configData?.smartcashSecureConfig?.otpConfig?.resendOtpTimer ?? 30,
            otpLength: configData?.smartcashSecureConfig?.otpConfig?.otpLength ?? OTP_LENGTH
          },
          pinConfig: {
            showCloseIcn: configData?.smartcashSecureConfig?.pinConfig?.showCloseIcn ?? false,
            pinLength: configData?.smartcashSecureConfig?.pinConfig?.pinLength ?? 4
          }
        },
        smallDeviceConfig: {
          width: configData?.smallDeviceConfig?.width ?? 321,
          height: configData?.smallDeviceConfig?.height ?? 531
        },
        paymentGatewayConfig: {
          PAYSTACK: {
            betaCode: configData?.paymentGatewayConfig?.PAYSTACK?.betaCode ?? "",
            name: configData?.paymentGatewayConfig?.PAYSTACK?.name ?? "",
            isEnabled: configData?.paymentGatewayConfig?.PAYSTACK?.isEnabled ?? false,
            publicKey: configData?.paymentGatewayConfig?.PAYSTACK?.publicKey ?? "",
            allowedPayOptions: configData?.paymentGatewayConfig?.PAYSTACK?.allowedPayOptions ?? [],
            emailConfig: {
              emailRegex: configData?.paymentGatewayConfig?.PAYSTACK?.emailConfig?.emailRegex ?? "",
              maxEmailLength: configData?.paymentGatewayConfig?.PAYSTACK?.emailConfig?.maxEmailLength ?? 100
            }
          },
          UBA: {
            betaCode: configData?.paymentGatewayConfig?.UBA?.betaCode ?? "",
            name: configData?.paymentGatewayConfig?.UBA?.name ?? "",
            isEnabled: configData?.paymentGatewayConfig?.UBA?.isEnabled ?? false,
            publicKey: configData?.paymentGatewayConfig?.UBA?.publicKey ?? "",
            allowedPayOptions: configData?.paymentGatewayConfig?.UBA?.allowedPayOptions ?? [],
            emailConfig: {
              emailRegex: configData?.paymentGatewayConfig?.UBA?.emailConfig?.emailRegex ?? "",
              maxEmailLength: configData?.paymentGatewayConfig?.UBA?.emailConfig?.maxEmailLength ?? 100
            }
          }
        },
        responsiveModeEnable: configData?.responsiveModeEnable ?? false,
        customEventMgmtConfig: {
          eventsEnabled: configData?.customEventMgmtConfig?.eventsEnabled ?? false
        },
        seoConfig: {
          description: configData?.seoConfig?.description ?? "",
          keywords: configData?.seoConfig?.keywords ?? ""
        },
        buyAirtimeConfig: {
          amountConfig: configData?.buyAirtimeConfig?.amountConfig ?? null as any
        },
        enableMsisdnSpace: configData?.enableMsisdnSpace ?? false
      }

      // basic config data at launch has been addded here to the store state
      if (!state.basicConfig) {
        state.basicConfig = { ...initialState.basicConfig };
      }
      state.basicConfig = {
        ...state.basicConfig,
        customerCareNo: configData?.customer_care_no,
        msisdnLength: configData?.msisdn_length,
        backgroundThreadFreq: configData?.background_thread_freq,
        currency: configData?.currency,
        ussdGSMCode: configData?.ussd_gsm_code,
        ussdAMCode: configData?.ussd_am_code,
        otpAttempts: configData?.otp_attempts,
        bundleType: configData?.bundleType,
        invalidAMPinStatuses: configData?.invalidAMPinStatuses,
        rechargeAirtimeFav: configData?.rechargeAirtimeFav,
        buyBundleFav: configData?.buyBundleFav,
        sendMoneyFav: configData?.sendMoneyFav,
        payBillFav: configData?.payBillFav,
        ussdPayBillCode: configData?.ussdPayBillCode,
        recentContactsCount: state?.basicConfig?.recentContactsCount && configData?.recentContactsCount,
      }

      // limit config data at launch has been addded here to the store state
    },
    launchConfigApiFailed: (state, action) => {

    },
    getUserAttribute: (state, action) => { },
    getUserAttributeSucess: (state, action) => {
      state.userAttribute = action.payload;
    },
    getUserAttributeFailed: (state, action) => {
      state.userAttribute = "";
    }
  },
  extraReducers: (builder) => {
    builder //clear config store
      .addCase(clearStore, (state, action) => {
        return initialState;
      })?.addDefaultCase((state, action) => { })
  }
});

export const {
  callConfigApi,
  configApiSucess,
  configApiFailed,
  callLaunchConfigApi,
  launchConfigApiSucess,
  launchConfigApiFailed,
  getUserAttribute,
  getUserAttributeSucess,
  getUserAttributeFailed,
  callTransactionLimitConfigApi,
  transactionLimitConfigApiSucess,
  transactionLimitConfigApiFailed
} = configSlice.actions;
export default configSlice.reducer;
